module.exports = __webpack_public_path__ + "media/images/charts/PemegangSaham-PieChart-da36795edc49d97d07b413fa9c56e033.jpg";